import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5f845882"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top-container searchTop"
}, null, -1));
const _hoisted_3 = {
  class: "dialog-footer"
};
import { findTree, updateRegion } from "@/api/system1/tenant";
import { ref, unref, reactive, toRefs, watch, onMounted, nextTick } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { getCurrentInstance } from "vue";
export default {
  __name: 'index',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const form = ref(null);
    // 地区状态数据字典
    const visibleOptions = ref([{
      dictValue: 1,
      dictLabel: "显示"
    }, {
      dictValue: 0,
      dictLabel: "隐藏"
    }]);
    const visibleOptions1 = ref([{
      dictValue: 1,
      dictLabel: "是"
    }, {
      dictValue: 0,
      dictLabel: "否"
    }]);
    // 地区树选项
    const menuOptions = ref([]);
    // 先new一个map用于数据保存
    const rowMaps = reactive(new Map());

    // 分块处理大数据集的工具函数
    const processDataInChunks = async (data, chunkSize = 100, processor) => {
      const chunks = [];
      for (let i = 0; i < data.length; i += chunkSize) {
        chunks.push(data.slice(i, i + chunkSize));
      }
      const results = [];
      for (let i = 0; i < chunks.length; i++) {
        const chunk = chunks[i];
        const processedChunk = await processor(chunk);
        results.push(...processedChunk);

        // 让出控制权给浏览器，防止阻塞UI
        await new Promise(resolve => requestAnimationFrame(resolve));
      }
      return results;
    };

    // 处理树形数据的函数
    const processTreeData = data => {
      if (!data || !Array.isArray(data)) return [];
      return data.map(item => {
        const processedItem = {
          ...item,
          hasChildren: item.children && item.children.length > 0,
          idList: [item.id],
          // 保持原始children数据用于懒加载，但添加标记表示已处理
          _originalChildren: item.children
        };

        // 对于显示的数据，清空children避免一次性渲染过多节点
        if (processedItem.hasChildren) {
          processedItem.children = null;
        }
        return processedItem;
      });
    };
    const state = reactive({
      showTable: true,
      tableDataCopy: [],
      allTreeData: [],
      // 存储完整的树形数据
      searchFormData: [{
        prop: "keywords",
        label: "地区名称",
        placeholder: "请输入地区名称查询",
        type: "text",
        isSelect: false,
        span: 4
      }],
      formHandle: [{
        label: "搜索",
        type: "primary",
        icon: "el-icon-search",
        class: "btn-liquid",
        handle: () => handleQuery()
      }, {
        label: "重置",
        icon: "el-icon-refresh",
        class: "commonDarkBtn",
        handle: () => resetQuery()
      }],
      buttonsList: [
        // {
        //   buttonName: "新增",
        //   buttonStyle: "primary",
        //   hasPermi: ["sys:menu:add"],
        //   className: "addBtn",
        //   buttonIcon: "Plus",
        //   exp: () => handleAdd(),
        // },
      ],
      tableHeader: [{
        prop: "name",
        label: "地区名称"
      }, {
        prop: "id",
        label: "地区编码"
      }, {
        prop: "operation",
        label: "操作",
        width: "70px",
        fixed: "right",
        operation: [{
          name: "修改",
          clickFun: row => handleUpdate(row),
          hasPermi: ["sys:menu:edit"]
        }]
      }],
      formData: [{
        prop: "name",
        label: "地区名称",
        placeholder: "请输入地区名称",
        type: "text",
        isSelect: false,
        span: 24
      }, {
        prop: "id",
        label: "地区编码",
        placeholder: "请输入地区编码",
        type: "text",
        isSelect: false,
        span: 24
      }, {
        prop: "pinyin",
        label: "地区全拼",
        placeholder: "地区全拼",
        type: "text",
        isSelect: false,
        span: 24
      }],
      // 遮罩层
      loading: true,
      // 地区表格树数据
      regionList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        keywords: ''
      },
      // 表单参数
      form: {
        id: undefined,
        name: '',
        pinyin: ''
      },
      // 表单校验
      rules: {
        name: [{
          required: true,
          message: "地区名称不能为空",
          trigger: "change"
        }],
        sort: [{
          required: true,
          message: "地区顺序不能为空",
          trigger: "change"
        }],
        routePath: [{
          required: true,
          message: "路由地址不能为空",
          trigger: "change"
        }],
        routeName: [{
          required: true,
          message: "路由名称不能为空",
          trigger: "change"
        }],
        visible: [{
          required: true,
          message: "地区状态不能为空",
          trigger: "change"
        }]
      },
      saveLoading: false,
      currentOpentree: null
    });
    onMounted(() => {
      // 初始化加载数据
      getList();

      // 有问题
      // proxy.getDicts("sys_show_hide").then((response) => {
      //   visibleOptions.value = response.data;
      // });
    });
    // 展开
    function load(tree, treeNode, resolve) {
      state.currentOpentree = JSON.parse(JSON.stringify(tree));
      // 层级关系备份
      const idCopy = JSON.parse(JSON.stringify(tree.idList));
      // 查找下一层数据
      let resolveArr = state.tableDataCopy;
      let id;

      // 根据idList路径找到对应的数据节点
      while (id = tree.idList.shift()) {
        const tarItem = resolveArr.find(item => item.id === id);
        if (!tarItem) {
          console.error('找不到对应的数据节点:', id);
          resolve([]);
          return;
        }
        console.log('找到节点:', tarItem);

        // 标记已加载子节点
        tarItem.loadedChildren = true;

        // 获取子节点数据，优先使用_originalChildren，如果没有则使用children
        const childrenData = tarItem._originalChildren || tarItem.children;
        console.log('子节点数据:', childrenData);
        resolveArr = childrenData || [];
      }

      // 处理下一层数据的属性
      if (resolveArr && resolveArr.length > 0) {
        resolveArr = JSON.parse(JSON.stringify(resolveArr));
        resolveArr.forEach(item => {
          item.hasChildren = item.children && item.children.length > 0 || item._originalChildren && item._originalChildren.length > 0;
          // 保存原始children数据用于后续懒加载
          item._originalChildren = item.children;
          item.children = null; // 清空children，实现懒加载

          // 此处需要深拷贝，以防各个item的idList混乱
          item.idList = JSON.parse(JSON.stringify(idCopy));
          item.idList.push(item.id);
        });
        console.log('处理后的子节点数据:', resolveArr);
      } else {
        console.log('没有找到子节点数据');
      }

      // 标识已经加载子节点
      tree.loadedChildren = true;
      // 渲染子节点
      resolve(resolveArr || []);
      rowMaps.set(tree.id, {
        tree: state.currentOpentree,
        treeNode,
        resolve
      });
    }

    /** 查询地区列表 */
    const getList = async function () {
      state.loading = true;
      try {
        const response = await findTree();
        console.log('API响应数据:', response.data);

        // 如果数据量很大，使用分块处理
        if (response.data && response.data.children && response.data.children.length > 0) {
          const allData = response.data.children;
          state.allTreeData = allData; // 保存完整数据

          // 只显示第一级数据，其他数据通过懒加载获取
          const firstLevelData = await processDataInChunks(allData.slice(0, 50),
          // 只处理前50个省份，避免一次性加载过多
          10,
          // 每批处理10个
          processTreeData);

          // 设置表格数据
          state.regionList = {
            rows: firstLevelData
          };

          // 保存完整数据用于懒加载，保持原始数据结构
          state.tableDataCopy = JSON.parse(JSON.stringify(allData));
        } else {
          state.regionList = {
            rows: []
          };
          state.tableDataCopy = [];
        }
      } catch (error) {
        console.error('获取地区数据失败:', error);
        ElMessage.error('获取地区数据失败');
        state.regionList = {
          rows: []
        };
        state.tableDataCopy = [];
      } finally {
        state.loading = false;
      }
    };
    // 取消按钮
    const cancel = function () {
      state.open = false;
      reset();
    };
    // 表单重置
    const reset = function () {
      state.form = {
        id: undefined,
        name: '',
        pinyin: ''
      };
    };
    // 搜索功能
    const searchTreeData = (data, keyword) => {
      if (!keyword) return data;
      const result = [];
      const searchKeyword = keyword.toLowerCase();
      const searchInNode = node => {
        if (node.name && node.name.toLowerCase().includes(searchKeyword)) {
          result.push({
            ...node,
            hasChildren: node.children && node.children.length > 0,
            _originalChildren: node.children,
            // 保持原始children数据
            children: null,
            // 清空children实现懒加载
            idList: [node.id]
          });
        }
        if (node.children && Array.isArray(node.children)) {
          node.children.forEach(child => searchInNode(child));
        }
      };
      data.forEach(node => searchInNode(node));
      return result;
    };

    /** 搜索按钮操作 */
    const handleQuery = async function () {
      const keyword = state.queryParams.keywords;
      if (!keyword) {
        // 如果没有搜索关键词，重新加载完整数据
        await getList();
        return;
      }

      // 如果有搜索关键词，在已加载的数据中搜索
      state.loading = true;
      try {
        const searchResults = await processDataInChunks(state.allTreeData, 50, chunk => searchTreeData(chunk, keyword));
        state.regionList = {
          rows: searchResults
        };
      } catch (error) {
        console.error('搜索失败:', error);
        ElMessage.error('搜索失败');
      } finally {
        state.loading = false;
      }
    };
    //重置按钮
    const resetQuery = function () {
      state.queryParams = {
        keywords: ''
      };
      handleQuery();
    };

    /** 修改按钮操作 */
    const handleUpdate = function (row) {
      state.open = true;
      state.title = "修改地区";
      state.form.id = row.id;
      state.form.name = row.name;
      state.form.pinyin = row.pinyin;
    };
    /** 提交按钮 */
    const submitForm = function () {
      const formRef = unref(form);
      formRef.commonForm.validate(valid => {
        if (valid) {
          state.saveLoading = true;
          if (state.form.id != undefined) {
            updateRegion(state.form).then(response => {
              if (response.code == 0) {
                ElMessage.success("修改成功");
                state.open = false;
                getList();
              } else {
                ElMessage.error(response.msg);
              }
              state.saveLoading = false;
            }).catch(() => {
              state.saveLoading = false;
            });
          } else {
            // addMenu(state.form)
            //   .then((response) => {
            //     if (response.code == 0) {
            //       ElMessage.success("新增成功");
            //       state.open = false;
            //       //新建后重置筛选
            //       state.queryParams = {
            //         name: undefined,
            //         visible:1,
            //       };
            //       getList();
            //     } else {
            //       ElMessage.error(err.message);
            //     }
            //     state.saveLoading = false;
            //   })
            //   .catch((err) => {
            //     state.saveLoading = false;
            //   });
          }
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_commonTable = _resolveComponent("commonTable");
      const _component_commonForm = _resolveComponent("commonForm");
      const _component_el_button = _resolveComponent("el-button");
      const _component_commonDrawer = _resolveComponent("commonDrawer");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, state.showTable ? _withDirectives((_openBlock(), _createBlock(_component_commonTable, {
        key: 0,
        tableData: state.regionList,
        tableHeader: state.tableHeader,
        queryParams: state.queryParams,
        onGetList: getList,
        hasSelect: false,
        columnSetting: false,
        showPagination: false,
        rowKey: "id",
        treeProps: {
          children: 'children',
          hasChildren: 'hasChildren'
        },
        isLazy: true,
        load: load
      }, null, 8, ["tableData", "tableHeader", "queryParams"])), [[_directive_loading, state.loading]]) : _createCommentVNode("", true), _createVNode(_component_commonDrawer, {
        modelValue: state.open,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => state.open = $event),
        size: "700px",
        title: state.title,
        "close-on-click-modal": false,
        onClose: cancel
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitForm
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: cancel
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_commonForm, {
          ref_key: "form",
          ref: form,
          form: state.form,
          formRules: state.rules,
          formData: state.formData,
          isHandle: false
        }, null, 8, ["form", "formRules", "formData"])]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
};